// extracted by css-extract-rspack-plugin
export default {"root":"root-_gLDmm","title":"title-T28kPe","top-block":"top-block-_ftEcX","topBlock":"top-block-_ftEcX","navLink":"navLink-zFmGIm","buttonContainer":"buttonContainer-idAbdY"};